/**
 * A thin convenience wrapper around React.createElement in lieu of JSX.
 * Inspired by react-hyperscript (https://github.com/mlmorg/react-hyperscript)
 */

// Vendor imports
const classNames = require('classnames')
const _ = require('lodash')
const React = require('react')

const TAG_NAME_REGEXP = /^[a-z][a-z0-9-]*/
const ID_REGEXP = /#[a-z][^\s.]*/
const CLASSNAMES_REGEXP = /(\.[_a-zA-Z]+[_a-zA-Z0-9-]*)+/

module.exports = hyperscript

function hyperscript(...args) {
  // Support shorthand for fragments
  if (isFragmentArgs(args)) {
    return React.createElement(React.Fragment, null, ...args[0])
  }
  // Parse arguments
  let type = args[0]
  let props
  let children
  if (isPropsArg(args[1])) {
    props = args[1]
    children = args.slice(2)
  } else {
    props = {}
    children = args.slice(1)
  }
  if (_.isString(type)) {
    props = parseProps(props)
    type = parseSelector(type, props)
  }
  // Create a React Element
  return React.createElement(type, props, ...children)
}

function isFragmentArgs(args) {
  return args.length === 1 && _.isArray(args[0])
}

function isPropsArg(arg) {
  return _.isPlainObject(arg) && !React.isValidElement(arg)
}

function parseProps({ aria, dataset, ...props }) {
  // Support nested aria attributes
  if (aria) {
    Object.keys(aria).forEach(key => {
      props[`aria-${key}`] = aria[key]
    })
  }
  // Support nested dataset attributes
  if (dataset) {
    Object.keys(dataset).forEach(key => {
      props[`data-${_.kebabCase(key)}`] = dataset[key]
    })
  }
  return props
}

function parseSelector(selector, props) {
  // Parse `id` prop
  const idMatch = selector.match(ID_REGEXP)
  if (idMatch) {
    props.id = idMatch[0].substr(1)
  }
  // Parse `className` prop
  const classNamesMatch = selector.match(CLASSNAMES_REGEXP)
  if (classNamesMatch) {
    props.className = classNames(
      ...classNamesMatch[0].substr(1).split('.'),
      props.className
    )
  }
  // Parse element `tagName`
  const tagMatch = selector.match(TAG_NAME_REGEXP)
  return tagMatch ? tagMatch[0] : 'div'
}
